import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/manifesto')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-6 md:py-16 ">
      <section className="mb-12">
        <h2 className="text-2xl mb-4 font-PPMondwest">Poker is raw.</h2>
        <p className="text-md leading-relaxed mb-6">
          It illustrates life in a way very few games do. Every decision is made
          with incomplete information, every hand tests your ability to read
          people as much as cards, and every session forces you to separate
          short-term luck from long-term skill. In both poker and life, success
          comes not from the cards you're dealt, but from how you play them -
          knowing when to hold firm, when to fold, and when to risk everything
          on conviction.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl mb-4 font-PPMondwest">Poker is beautiful.</h2>
        <p className="text-md leading-relaxed mb-6">
          And so too should the interfaces we use to play it. Beautiful not only
          in looks, but in performance, speed, and consistency. The game demands
          clarity of thought, precision, and focus. The software we use should
          meet that same standard. Poker demands the most out of players, and
          players should demand the most out of it.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-PPMondwest">
          Poker is poker, only on <span className="font-medium">Powka</span>.
        </h2>
      </section>
    </div>
  )
}
